import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'trqk-logo-rounded';

const originalDimensions = {
    height: 64.8,
    width: 127.761,
};

export const IconTrqkLogoRounded = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'primary-500';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
        >
            <title id={iconId}>Trqk Logo</title>
            <g transform="translate(0 .1)" id="g16" display="inline">
                <g id="g14">
                    <path
                        id="path12"
                        d="M82.9 33.7h-.1M32.7 3.5H3.4C1.5 3.5 0 5 0 6.9s1.5 3.4 3.4 3.4h11.1V48c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6V10.3h11.1c1.9 0 3.4-1.5 3.4-3.4-.1-1.9-1.7-3.4-3.5-3.4zm79.2 26.1l7.6-7.9c2.1-2.1.6-5.7-2.4-5.7-.9 0-1.8.4-2.4 1L102 30.1V3.5c0-2-1.6-3.6-3.6-3.6s-3.6 1.6-3.6 3.6v44.2c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6v-7.9l3.9-4c7.3.2 13.4 5.6 14.8 12.6.3 1.7 1.8 2.9 3.5 2.9 2.3 0 3.9-2.1 3.5-4.3-1.7-8.3-7.8-15-15.8-17.4zm-76.1 2.7c0-5.6 4.5-10.6 10.1-10.9h1.5c1.6.1 3.2-.8 3.7-2.3.8-2.2-.7-4.6-3-4.8-.8-.1-1.6-.1-2.3-.1-9.5.3-17.2 8.7-17.2 18.1v15.5c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6zm36.6-18.1c-11.8-1.1-21.6 8.6-20.8 20.4.7 9.2 8 16.7 17.2 17.5 2.5.2 4.9 0 7.1-.7 1.5-.4 2.5-1.8 2.5-3.3v-.3c0-2.3-2.3-4-4.5-3.3-1.4.4-3 .6-4.6.4-5.6-.6-10.1-5.2-10.5-10.8-.6-7.3 5.5-13.4 12.8-12.8 6 .5 10.8 6.1 10.8 12.1v27.7c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6V33.5c0-9.9-7.4-18.4-17.2-19.3z"
                        fill={fill}
                    />
                </g>
            </g>
        </svg>
    );
};
